import { Empty, Typography } from "antd"

export const customEmptyMessage = (message: string = "No records Found") => {

  let locale = {
    emptyText: (

      <Empty description={
        <Typography.Text>
          {message}
        </Typography.Text>
      }></Empty>
    )
  };
    return locale; 
  }


